import Api from './Api';

export default {
  getOne: (lessonId, params) => Api.get(`/v1/user/lessons/${lessonId}`, { params }),
  fetch: params => Api.get('/v1/user/lessons', { params }),
  fetchIndividual: params => Api.get('/v1/user/lessons/individuals', { params }),
  addAnswer: (lessonId, params) => Api.post(`/v1/user/lessons/${lessonId}/answer`, params),
  getAnswer: (lessonId, answerId, params) => Api.get(`/v1/user/lessons/${lessonId}/answer/${answerId}`, { params }),
  addAnswerComment: (lessonId, answerId, params) => Api.post(`/v1/user/lessons/${lessonId}/answer/${answerId}/comment`, params),
  uploadAnswerFile: (lessonId, answerId, params, onProgress) => Api.post(`/v1/user/lessons/${lessonId}/answer/${answerId}/files`, params, {
    onUploadProgress: onProgress,
    timeout: 120000,
  }),
  deleteAnswerFile: (lessonId, answerId, fileId) => Api.delete(`/v1/user/lessons/${lessonId}/answer/${answerId}/files/${fileId}`),
  saveAnswer: (lessonId, answerId, params) => Api.post(`/v1/user/lessons/${lessonId}/answer/${answerId}`, params),
  deleteAnswer: (lessonId, answerId) => Api.delete(`/v1/user/lessons/${lessonId}/answer/${answerId}`),
  setAnswerSendStatus: (lessonId, answerId, params) => Api.post(`/v1/user/lessons/${lessonId}/answer/${answerId}/send`, params),
  deleteAnswerComment: (lessonId, answerId, commentId) => Api.delete(`/v1/user/lessons/${lessonId}/answer/${answerId}/comment/${commentId}`),
  createRecord: params => Api.post('/v1/user/lessonRecords', params),
  deleteRecord: recordId => Api.delete(`/v1/user/lessonRecords/${recordId}`),
};
